let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lRy8u")).then(() => parcelRequire('eNRbc'));